module.exports = __webpack_public_path__ + "static/images/finance-2.e5269f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/finance-2.png
// module id = +FPt
// module chunks = 8